import styled, { css } from 'styled-components'

import { spacing } from '../../../themes'
import type { Layout } from '../styles'

export const Container = styled.div<{ layout: Layout }>`
  display: flex;
  flex-direction: column;
  padding: ${spacing(3)};

  ${({ layout }) =>
    (layout === 'horizontal' || layout === 'horizontal-embedded') &&
    css`
      padding: 0;
      width: 100%;
      overflow: hidden;
      margin-left: ${spacing(3)};
    `}
`
